import isEmail from "validator/es/lib/isEmail";
import { FieldValidator } from "final-form";

export const firstnameValidator: FieldValidator<string> = (value) => {
  if (!value) {
    return "authModule.errors.required";
  }
};

export const lastnameValidator: FieldValidator<string> = (value) => {
  if (!value) {
    return "authModule.errors.required";
  }
};

export const emailValidator: FieldValidator<string> = (value) => {
  if (!value) {
    return "authModule.errors.required";
  }

  if (!isEmail(value)) {
    return "authModule.errors.invalidEmail";
  }
};

export const passwordValidator: FieldValidator<string> = (value) => {
  if (!value) {
    return "authModule.errors.required";
  }

  if (value.length < 8) {
    return "authModule.errors.password.tooShort";
  }

  if (!/^(?=.*[a-z]).{1,}$/.test(value)) {
    return "authModule.errors.password.lowercase";
  }

  if (!/^(?=.*[A-Z]).{1,}$/.test(value)) {
    return "authModule.errors.password.uppercase";
  }

  if (!/^(?=.*\d).{1,}$/.test(value)) {
    return "authModule.errors.password.number";
  }

  if (!/^(?=.*[^A-Za-z0-9]).{1,}$/.test(value)) {
    return "authModule.errors.password.specialCharacter";
  }
};
